// extracted by mini-css-extract-plugin
export default {"container":"roadmap-step-right_container__-WZ5v","container1":"roadmap-step-right_container1__ZDU+k","text":"roadmap-step-right_text__N1yip"};